<div class="image-preview" [style.background-image]="`url(${image()})`">
  <div class="download-overlay">
    <onyx-icon-button
      variant="transparent"
      color="black"
      [size]="32"
      [disabledActiveHover]="true"
      (click)="loading() ? null : downloadFiles(); $event.stopPropagation()"
    >
      @if (loading()) {
        <onyx-spinner color="white" [size]="16"></onyx-spinner>
      } @else {
        <onyx-icon name="download-outlined" [size]="20"></onyx-icon>
      }
    </onyx-icon-button>
  </div>

  <div class="heading-overlay">
    <div class="wrapper">
      <p class="f-body-m f-medium">{{ title() | translate }}</p>

      @let imageCount = files().length;
      @let hasMultiple = imageCount > 1;
      @if (hasMultiple || note()) {
        <span class="description f-body-xs">
          @if (hasMultiple) {
            {{ `${imageCount} ${('labels.images' | translate | lowercase)}` }}
          }

          @if (hasMultiple && note()) {
            ·
          }

          @if (note(); as note) {
            {{ note }}
          }
        </span>
      }
    </div>
  </div>
</div>
